import { ProgramsSlugsPage } from '@components/buzzkuri/pages/ProgramsSlugs'
import { getProgramsPaths } from '@components/buzzkuri/pages/ProgramsSlugs/functions'
import {
  DEFAULT_PROGRAMS_PATHS,
  ProgramsPathsContext,
} from '@context/ProgramsPaths/Context'

import { GetServerSidePropsContext } from 'next'
import { ParsedUrlQuery } from 'querystring'
import React, { useContext, useEffect } from 'react'
import { ProgramDetailsPage } from '@components/buzzkuri/pages/ProgramDetail'
import { ProgramDetailPageRes } from '@type/buzzkuri/program-detail'
import {
  ProgramCategoryList,
  ProgramsCategoryPageRes,
  ProgramsSlugsPageRes,
  ProgramsSlugsPageResAndSlugs,
  Slugs,
} from '@type/buzzkuri/programs-categor'
import { BuzzkuriHead } from '@components/buzzkuri/shared/common/BuzzkuriHead'
import { ErrorStatus } from '@type/common'
import { ErrorPage } from '@components/buzzkuri/shared/common/ErrorPage'
import {
  NOT_FOUND_PAGE_PROPS,
  INTERNAL_SERVER_ERROR_PAGE_PROPS,
} from '@constants/common'
import { getProgramsSlugsPagePropsReq } from '../../utils/http'
import { MetaData } from '@type/buzzkuri/api'

const ProgramsSlugs = ({
  slugs,
  props,
  programCategoryList,
}: ProgramsSlugsPageResAndSlugs): JSX.Element => {
  const { setProgramsPaths } = useContext(ProgramsPathsContext)

  useEffect(() => {
    // slugs has 3 patten
    // case1: programs/[programId]
    // case2: programs/[tag]
    // case3: programs/[objective or targetGroup or genel or tag]
    // case4: programs/[objective or targetGroup or genel]/[targetGroup or genel]/...

    // run case3 & case4 only
    if (programCategoryList && slugs) {
      if (
        !(
          programCategoryList.tags.filter(({ name }) => name === slugs[0])
            .length > 0
        ) &&
        !(Number(slugs[0]) > 0)
      ) {
        setProgramsPaths({
          ...DEFAULT_PROGRAMS_PATHS,
          ...getProgramsPaths(slugs, programCategoryList),
        })
      }
    }
  }, [programCategoryList, setProgramsPaths, slugs])

  return (
    <>
      {'errorStatus' in props ? (
        <ErrorPage
          {...(props.errorStatus === 404
            ? NOT_FOUND_PAGE_PROPS
            : INTERNAL_SERVER_ERROR_PAGE_PROPS)}
        />
      ) : (
        <>
          <BuzzkuriHead
            metaData={(props as ProgramsSlugsPageRes).metaData as MetaData}
          />
          {!(Number(slugs[0]) > 0) ? (
            <ProgramsSlugsPage
              programsSlugsPageRes={props as ProgramsCategoryPageRes}
              {...{ programCategoryList, slugs }}
            />
          ) : (
            <ProgramDetailsPage {...(props as ProgramDetailPageRes)} />
          )}
        </>
      )}
    </>
  )
}

export default ProgramsSlugs

export async function getServerSideProps(
  context: GetServerSidePropsContext<ParsedUrlQuery>
): Promise<
  | {
      props: {
        slugs: Slugs
        props: ProgramsSlugsPageRes | ErrorStatus
        programCategoryList: ProgramCategoryList
      }
    }
  | { props: { props: ErrorStatus } }
> {
  return getProgramsSlugsPagePropsReq(context)
}
